import { triggerBlobDownload } from "@thalamos/frontend";
import {
  mayPractitionerDownloadAssessmentPdf,
  type Assessment,
} from "@thalamos/haven-common";

import api from "../../api/index.js";

/** How asking for a PDF to save went. */
export type PdfDownloadOutcome = "downloaded" | "failed";

// TODO(guest-settings): read the acting organisation's "Practitioners can
// download PDFs" setting from its effective configuration once the setting
// is declared; until then every organisation states the default, off.
const practitionersMayDownloadPdfs = false;

/**
 * Downloads the assessment as a PDF, where it is offered to the practitioner
 * reading it: they may read what it says, which the server tells by not
 * withholding its answers, and `mayPractitionerDownloadAssessmentPdf` allows
 * it. Undefined where it is not offered.
 */
export const assessmentPdfDownloadOf = (
  assessment: Pick<Assessment, "id" | "status" | "answersWithheld">,
): (() => Promise<PdfDownloadOutcome>) | undefined =>
  assessment.answersWithheld !== true &&
  mayPractitionerDownloadAssessmentPdf({
    assessment,
    practitionersMayDownloadPdfs,
  })
    ? async () => {
        const pdf = await api.assessment
          .pdf(assessment.id)
          .catch(() => undefined);

        if (pdf === undefined) {
          return "failed";
        }

        triggerBlobDownload(pdf);
        return "downloaded";
      }
    : undefined;
